import Fetch from './fetch';

const noOpErrCallback = () => {
  console.warn('A recoverable error occurred compiling search statistics');
};

const SearchApi = {
  filterSearchableObjectIds: (results) => Fetch.post('search/filter_search_results', { results }),
  editorFilterSearchableObjectIds: (results) => Fetch.post('search/editor_filter_search_results', results),
  filterSearchableObjectIdsAndCombine: (results) =>
    Fetch.post('search/filter_search_results', { results, combine_guide_hits: true }),
  logSearchResults: (results) =>
    Fetch.post('search/log_search_results', { results, combine_guide_hits: true }, noOpErrCallback),
};
export default SearchApi;
